export default function WiFiRouter(props: any) {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M26.7037 18.7114H5.26875C3.39767 18.7114 1.88086 20.2282 1.88086 22.0993V22.6857C1.88086 24.5568 3.39767 26.0736 5.26875 26.0736H26.7037C28.5748 26.0736 30.0916 24.5568 30.0916 22.6857V22.0993C30.0916 20.2282 28.5748 18.7114 26.7037 18.7114Z"
                stroke="#757575"
                strokeWidth="1.2"
            />
            <path
                d="M20.2105 23.2347C20.6756 23.2347 21.0526 22.8577 21.0526 22.3926C21.0526 21.9276 20.6756 21.5505 20.2105 21.5505C19.7454 21.5505 19.3684 21.9276 19.3684 22.3926C19.3684 22.8577 19.7454 23.2347 20.2105 23.2347Z"
                fill="#757575"
            />
            <path
                d="M23.1578 23.2347C23.6229 23.2347 23.9999 22.8577 23.9999 22.3926C23.9999 21.9276 23.6229 21.5505 23.1578 21.5505C22.6927 21.5505 22.3157 21.9276 22.3157 22.3926C22.3157 22.8577 22.6927 23.2347 23.1578 23.2347Z"
                fill="#757575"
            />
            <path
                d="M26.1053 23.2347C26.5704 23.2347 26.9474 22.8577 26.9474 22.3926C26.9474 21.9276 26.5704 21.5505 26.1053 21.5505C25.6402 21.5505 25.2632 21.9276 25.2632 22.3926C25.2632 22.8577 25.6402 23.2347 26.1053 23.2347Z"
                fill="#757575"
            />
            <path d="M26.5214 6.56299L23.9614 18.4986" stroke="#757575" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M5.45127 6.56299L8.01123 18.4986" stroke="#757575" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M6.52881 28.582H9.7864" stroke="#757575" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M22.186 28.582H25.4436" stroke="#757575" strokeWidth="1.2" strokeLinecap="round" />
            <path
                d="M16.0239 12.1665C16.5762 12.1665 17.0239 11.7188 17.0239 11.1665C17.0239 10.6142 16.5762 10.1665 16.0239 10.1665C15.4716 10.1665 15.0239 10.6142 15.0239 11.1665C15.0239 11.7188 15.4716 12.1665 16.0239 12.1665Z"
                fill="#757575"
            />
            <path
                d="M20.7153 5.97101C19.4739 4.84946 17.8287 4.1665 16.024 4.1665C14.2161 4.1665 12.5683 4.85189 11.3262 5.97702"
                stroke="#757575"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.6965 8.90627C18.0545 8.14793 17.0955 7.6665 16.0241 7.6665C14.9185 7.6665 13.9327 8.17909 13.2913 8.97957"
                stroke="#757575"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
